import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { skip } from 'rxjs/operators';
import { Location } from '@angular/common';
import { CoreState } from '@core/store/core.reducers';
import { CoreSelectors } from '@core/store/core.selectors';
import { Store } from '@ngrx/store';
import { catchError, combineLatest, Observable, take, throwError } from 'rxjs';
import { Revisione53Service } from '../../../../../features/revisione53/core/revisione53.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Revisione53CoreSelectors } from '../../../../../features/revisione53/core/store/selectors/core.selectors';
import { IRevisione as IRevisione53 } from '../../../../../features/revisione53/core/models/interfaces/revisione.interface';
import { VerbaleRevisionePDFGenerator as VerbaleRevisione53PDFGenerator } from '../../../../../features/revisione53/print/TEMPLATE_VerbaleDiRevisioneMinisteroPDF44';
import pdfMake from 'pdfmake/build/pdfmake';
import { Router } from '@angular/router';
import { TipoDocumento } from '@core/helpers/constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    isConnected$: Observable<boolean>;

    constructor(
        private toastr: ToastrService,
        private location: Location,
        private store: Store<CoreState>,
        // private revisione49Service: Revisione49Service,
        private revisione53Service: Revisione53Service,
        private router: Router
    ) {
        this.isConnected$ = this.store.select(CoreSelectors.isOnline);
    }

    ngOnInit(): void {
        this.isConnected$.pipe(skip(1)).subscribe((isConnected) => {
            if (isConnected) {
                this.toastr.success('Sei online, sarà possibile effettuare tutte le operazioni', 'Online');
            } else {
                this.toastr.warning('Sei offline, sarà possibile salvare le modifiche solo localmente', 'Offline');
            }
        });
    }

    goToList(): void {
        this.router.navigate(['/prese-in-carico']);
    }

    goTop() {
        window.scroll(0, 0);
    }

    instantSave() {
        this.revisione53Service
            .save(true, false)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    this.toastr.error('Si è verificato un errore durante il salvataggio', null, { timeOut: 1500 });
                    return throwError(() => err);
                })
            )
            .subscribe((res) => {
                this.toastr.success(`Salvataggio manuale sul server effettuato correttamente`, null, { timeOut: 1500 });
            });
    }

    isInstantSaveVisible(): boolean {
        if (this.router.url.includes('revisione53')) {
            return true;
        } else {
            return false;
        }
    }

    instantPrint() {
        // this.store.select(Revisione49CoreSelectors.getRevisione).pipe(
        combineLatest([this.store.select(Revisione53CoreSelectors.getRevisione), this.revisione53Service.getIsSezioneIValid$()])
            .pipe(take(1))
            .subscribe(([revisione, isSezioneIValid]: [IRevisione53, boolean]) => {
                const generator = new VerbaleRevisione53PDFGenerator(revisione, TipoDocumento.RILEVAZIONE, isSezioneIValid);
                const fonts = generator.getFonts();
                const generatedPdfDefinition = generator.generate();
                if (revisione.tipodocumento.includes('VERB')) {
                    pdfMake.createPdf(generatedPdfDefinition).download('Verbale.pdf');
                } else if (revisione.tipodocumento.includes('ACC')) {
                    pdfMake.createPdf(generatedPdfDefinition).download('Accertamento.pdf');
                }
            });
    }

    isInstantPrintVisible(): boolean {
        if (this.router.url.includes('revisione53') && !this.router.url.includes('gestione-stampe')) {
            return true;
        } else {
            return false;
        }
    }
}
